import React from 'react';
import { motion } from 'framer-motion';
import { MolecularBackdrop } from '../components/MolecularBackdrop';
import { ArrowRight, Clock, Sparkles, MapPin, Gift } from 'lucide-react';
interface Props {
  onStart: () => void;
  onOpenMap: () => void;
}
export function SlideIntro({
  onStart,
  onOpenMap
}: Props) {
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="flex-1 flex flex-col relative px-5 pt-16 pb-24 overflow-y-auto" data-id="element-566">
      <MolecularBackdrop variant="nodes" data-id="element-567" />

      <div className="relative z-10 flex-1 flex flex-col" data-id="element-568">
        {/* Header Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-6 text-center mt-2" data-id="element-569">
          <div className="flex justify-center mb-5" data-id="element-570">
            <img src="https://cdn.magicpatterns.com/uploads/hvXWezQGzzzvUw2kM2zTk7/Screenshot_2026-05-12_at_11.29.04.png" alt="SNMMI 2026" className="h-12 w-auto rounded-lg shadow-sm border border-slate-200 bg-white p-1" data-id="element-571" />
          </div>
          <h1 className="text-[28px] sm:text-[32px] font-display font-bold text-slate-900 leading-[1.15] mb-3" data-id="element-572">
            How does your perspective compare with your peers?
          </h1>
          <p className="text-slate-600 text-[13px] leading-relaxed max-w-[300px] mx-auto" data-id="element-573">
            Take the 60-second SNMMI Industry Pulse. Benchmark your thinking
            against fellow attendees—and enter today's premium prize draw.
          </p>
        </motion.div>

        {/* Prize Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-white border border-slate-200 rounded-2xl p-4 shadow-[0_8px_24px_-12px_rgba(0,80,114,0.15)] mb-4 flex flex-col items-center justify-center" data-id="element-574">
          <div className="flex items-center gap-2 mb-2" data-id="element-575">
            <Gift size={16} className="text-minerva-blue" data-id="element-576" />
            <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wide" data-id="element-577">
              Win Premium Prizes
            </h3>
          </div>
          <p className="text-xs text-slate-500 text-center mb-3" data-id="element-578">
            Complete the pulse to enter today's draw.
          </p>
          <div className="flex items-center justify-center gap-1.5 text-[10px] font-semibold text-slate-400 uppercase tracking-widest border-t border-slate-100 pt-3 w-full" data-id="element-579">
            <Clock size={12} data-id="element-580" />
            <span data-id="element-581">Entries close daily at 4:00 PM</span>
          </div>
        </motion.div>

        {/* Booth Incentive Strip */}
        <motion.button onClick={onOpenMap} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} whileTap={{
        scale: 0.98
      }} className="relative rounded-2xl p-[1px] bg-gradient-to-r from-minerva-blue via-minerva-cyan to-minerva-blue mb-6 overflow-hidden shadow-[0_0_20px_rgba(0,224,255,0.2)] w-full text-left" data-id="element-582">
          {/* Shimmer effect */}
          <motion.div className="absolute inset-0 w-[200%] bg-gradient-to-r from-transparent via-white/40 to-transparent -skew-x-12" animate={{
          x: ['-100%', '100%']
        }} transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: 'easeInOut',
          repeatDelay: 1
        }} data-id="element-583" />
          <div className="bg-white rounded-[15px] px-4 py-3 flex items-center justify-between relative z-10" data-id="element-584">
            <div className="flex flex-col" data-id="element-585">
              <span className="text-[10px] font-bold text-minerva-blue uppercase tracking-widest flex items-center gap-1" data-id="element-586">
                <MapPin size={10} data-id="element-587" />
                Booth #1762
              </span>
              <span className="text-sm font-bold text-slate-900" data-id="element-588">
                DOUBLE your chances
              </span>
            </div>
            <div className="w-10 h-10 rounded-full bg-minerva-blue/10 flex items-center justify-center" data-id="element-589">
              <Sparkles size={20} className="text-minerva-blue" data-id="element-590" />
            </div>
          </div>
        </motion.button>

        {/* CTA */}
        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} whileTap={{
        scale: 0.97
      }} onClick={onStart} className="mt-auto w-full h-14 rounded-2xl bg-minerva-blue text-white font-semibold flex items-center justify-center gap-2 shadow-[0_8px_24px_-6px_rgba(0,133,189,0.5)] hover:bg-minerva-dark transition-colors" data-id="element-591">
          Start the challenge
          <ArrowRight size={18} data-id="element-592" />
        </motion.button>
      </div>
    </motion.div>;
}